module.exports = __webpack_public_path__ + "static/media/50euro.21ce70e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/50euro.jpg
// module id = 930
// module chunks = 0